// Client mirror of functions/backend/agent/consent.js so the UI can show the
// same "the assistant can reach this person" state the orchestrator computes.
// Keep in sync with consent.js (isContactableRecipient / isPhysicallyContactable).

// Kept identical to consent.js EMAIL_REGEX (+ the 1..254 length guard) so the
// client and orchestrator agree on what counts as a valid email.
const EMAIL_RE = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)*\.[^\s@.]{2,}$/;

function isValidEmail(email) {
  const trimmed = String(email || "").trim();
  if (trimmed.length === 0 || trimmed.length > 254) return false;
  return EMAIL_RE.test(trimmed);
}

function isActive(rel) {
  return String(rel && rel.status || "").toLowerCase() === "active";
}

// Recipient hasn't opted out of anything.
function notOptedOut(rel) {
  return rel && rel.optOut !== true && !rel.unsubscribedAt;
}

/** Consented + valid email + active + not opted out. */
export function isEmailContactable(rel) {
  if (!rel || !isActive(rel) || !notOptedOut(rel)) return false;
  const consented = rel.consent === true || !!rel.consentedAt;
  return consented && isValidEmail(rel.email);
}

/** Postal-consented + valid mailing address + active + not opted out. */
export function isPhysicalContactable(rel) {
  if (!rel || !isActive(rel) || !notOptedOut(rel)) return false;
  const consented = rel.postalConsent === true || !!rel.postalConsentedAt;
  const a = rel.address || {};
  return consented && !!(a.street && a.city && a.postalCode);
}

/** Reachable on either consented channel — matches the orchestrator's readiness count. */
export function isContactable(rel) {
  return isEmailContactable(rel) || isPhysicalContactable(rel);
}
